import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { lastValueFrom, Observable } from 'rxjs';
import { CustomerEnquiryForm } from '../../models/home/customer-enquiry-form';
import { IEnquiryEntityService } from '../../interfaces/enquiry/enquiry-component.interface';
import { Log, IShortLogger } from '../logger.service';

@Injectable({
  providedIn: 'root'
})
export class EnquiryEntityService implements IEnquiryEntityService {
  private readonly logger: IShortLogger<EnquiryEntityService> = Log.create(EnquiryEntityService);
  public baseUrl = environment.apiUrl;
  constructor(private http: HttpClient) {
  }

  async createCustomerEnquiry(customerEnquiry: CustomerEnquiryForm): Promise<CustomerEnquiryForm> {

    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(customerEnquiry);

    this.logger.i("Creating Customer Enquiry with body: ", body);
    let created = await lastValueFrom(this.http.post(`${this.baseUrl}/v1/enquiries`, body, { headers }));
    return created as CustomerEnquiryForm;
  }

  async getAllCustomerEnquiries(): Promise<any> {

    var res = await lastValueFrom(this.http.get(`${this.baseUrl}/v1/enquiries`));
    return res;
  }

  assignEnquiryToSalesPerson(objCustomerEnquiry: any): Observable<any> {
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(objCustomerEnquiry);
    return this.http.put(`${this.baseUrl}/v1/enquiries/assign`, body, { headers });
  }


  saveConversation(objCustomerEnquiry: any): Observable<any> {
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(objCustomerEnquiry);
    return this.http.put(`${this.baseUrl}/v1/enquiries/conversation`, body, { headers });
  }

  setEnquiryState(enquiryId: string, status: string):Observable<any> {
    const headers = { "content-type": "application/json" };
    const body = JSON.stringify(status);
    this.logger.i("enquiryId: ", enquiryId, " status: ", status);
    this.logger.i("Setting enquiry state with body: ", body,headers);
    return this.http.put(`${this.baseUrl}/v1/enquiries/${enquiryId}/status`, body, { headers });
  }


  async getCustomerEnquiriesByUserId(userId:string): Promise<any> {

    var res = await lastValueFrom(this.http.get(`${this.baseUrl}/v1/enquiries/user/${userId}`));
    return res;
  }
}
